module.exports = __webpack_public_path__ + "static/img/job-empty.e8f7cfd1.png";